import { action, computed, makeAutoObservable, observable } from "mobx";
import { StoreClass } from "./Store";
import { getProject, savePdf, saveProject, sendEmail, updateProject } from "../utils/api";
import { swalAlert } from "../utils/Swal";
import { Synerise } from "../utils/Synerise";

export const PAGE_DEFAULT = 'DEFAULT';
export const PAGE_SAVE = 'SAVE';

function validEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export default class SaveProject {
    @observable email = ''
    @observable agree = ''
    @observable id = ''
    @observable hash = ''
    @observable errors = observable.map([
        ['email', ''],
        ['agree', '']])
    @observable isSaving = false;
    @observable isSavingPdf = false;
    @observable page = PAGE_DEFAULT;

    store: StoreClass
    constructor({store}) {
        this.store = store
        makeAutoObservable(this)
        
        this.errors.set('email', '')
        this.errors.set('agree', '')
        
    }

    @action goToPage(pageName) {
        this.page = pageName;
    }

    @action goToSave() {
        this.page = PAGE_SAVE;
    }

    @action goToDefault() {
        this.page = PAGE_DEFAULT;
    }

    loadProjectFromUrl(){
        const u = new URL(window.location.href);
        const id = u.searchParams.get('id');
        const hash = u.searchParams.get('hash');
        if(id && hash){
            this.id = id;
            this.hash = hash;
            this.load();
        }
    }
    @computed get isSaved(){
        return Boolean(this.id && this.hash);
    }


    validate(name = null){

        if(name === 'email' || name === null) {
            
            if(validEmail(this.email)) {
                this.errors.set('email', '')
            }
            else {
                this.errors.set('email', 'Podany email jest nieprawidłowy.');
            }
        }

        // if(name === 'agree' || name === null) {
        //     if(this.agree === true) {
        //         this.errors.set('agree', '')
        //     }
        //     else {
        //         this.errors.set('agree', 'Musisz zaakceptować regulamin.');
        //     }
        // }


    }
    @computed get isValid(){
        return Array.from(this.errors.values()).every(v => v === '')
    }
    hasError(name){
        return this.errors.get(name) !== ''
    }

    @action updateField(name, value){
        this[name] = value;
        if(this.errors.has(name) && this.errors.get(name) !== ''){
            this.validate(name);
        }
    }

    @action async saveProjectData() {
        const isUpdate = Boolean(this.id && this.hash);
        const response = isUpdate
            ? await updateProject(this.preparePayload())
            : await saveProject(this.preparePayload());
        console.log({ response });
        if(response.data.status === true){
            this.updateUrl({
                id: response.data.id,
                hash: response.data.hash
            });
        }
        return response.data
    }
    @action async generatePdf() {
        this.isSaving = true
        this.isSavingPdf = true
        try {
            const isUpdate = Boolean(this.id && this.hash);
            const response = await savePdf({...this.preparePayload(), savedUrl: this.configurationUrl});
            console.log({ response });

            const disposition = response.headers?.['content-disposition']
                || response.headers?.['Content-Disposition']
                || response.request?.getResponseHeader?.('Content-Disposition');
            console.log({ disposition, headers: response.headers });
            let filename = 'download.pdf';
            if (disposition) {
                const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"'\s;]+)/i);
                if (match) {
                    filename = decodeURIComponent(match[1]);
                }
            }
            console.log({ filename });

            const blob = new Blob([response.data], {
                type: 'application/pdf'
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = filename;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            this.store.hasUnsavedChanges = false;
            Synerise.setStore(this.store);
            Synerise.push('configurator.save_pdf', {
                ...Synerise.getConfiguratorParams()
            });
            Synerise.push('product.configurator', {
                ...Synerise.getConfiguratorParams()
            });
          
            return response.data
        } catch (err) {
            console.error(err);
            throw err;
        } finally {
            this.isSaving = false
            this.isSavingPdf = false
        }
    }

    @action async save(){
        this.isSaving = true
        try {
            const data = await this.saveProjectData();
            swalAlert({
                title: "Zapisano",
                html: `Twój projekt został zapisany.`
            });
            return data;
        } catch (err) {
            swalAlert({
                title: "Błąd",
                html: `Wystąpił błąd podczas zapisywania projektu.<br>${err.toString()}`
            })
        } finally {
            this.isSaving = false
            this.store.closeSavingPopup();
        }
    }
    @action async send(){
        this.isSaving = true
        try {
            const data = await this.saveProjectData();
            const response = await sendEmail({...this.preparePayload(), savedUrl: this.configurationUrl});

            this.store.hasUnsavedChanges = false;
            Synerise.setStore(this.store);
            Synerise.push('form.submit', {
                email: this.email,
                newsletter_agreement_enabled: this.agree ? 'enabled' : 'disabled'
            });
            Synerise.setStore(this.store);
            Synerise.push('configurator.save_email', {
                email: this.email,
                ...Synerise.getConfiguratorParams()
            });
            Synerise.push('product.configurator', {
                ...Synerise.getConfiguratorParams()
            });

            this.store.closeSavingPopup();
            return data;
        } catch (err) {
            swalAlert({
                title: "Błąd",
                html: `Wystąpił błąd podczas zapisywania projektu.<br>${err.toString()}`
            })
        } finally {
            this.isSaving = false
        }
    }

    @computed get configurationUrl(){
        if (this.isSaved) {
            const u = new URL(window.location.href);
            u.searchParams.set('id', this.id);
            u.searchParams.set('hash', this.hash);
            return u.toString();
        }
        return null;
    }

    @action async copyLink() {
        if (!this.configurationUrl) return;
        try {
            await navigator.clipboard.writeText(this.configurationUrl);
            this.store.hasUnsavedChanges = false;
            Synerise.setStore(this.store);
            Synerise.push('configurator.copy_link', {
                ...Synerise.getConfiguratorParams()
            });
        } catch (err) {
            console.error('Failed to copy link', err);
        }
    }

    updateUrl({id, hash}){
        this.id = id;
        this.hash = hash;
        const u = new URL(window.location.href);
        u.searchParams.set('id', id);
        u.searchParams.set('hash', hash);
        window.history.replaceState({id, hash}, '', u);
    }

    cleanUrl(){
        const u = new URL(window.location.href);
        u.searchParams.delete('id');
        u.searchParams.delete('hash');
        window.history.replaceState({}, '', u);
    }

    // configurator_load_config:
    // path: /{projectId}/{projectHash}/configurator/{configuratorId}/load-configuration/{id}/{hash}
    // controller: App\Controller\ConfiguratorController::saveConfiguration
    @action async load(){
        // {"status":true,"id":5,"hash":"01KFZAMVVX66KN49N24YBPECJZ"}

        // this.id = 5;
        // this.hash = '01KFZAMVVX66KN49N24YBPECJZ';

        // 503 ?id=37&hash=01KN4MDN8XE3XRKHP7B6TTNX4Q
        // this.id = 37;
        // this.hash = '01KN4MDN8XE3XRKHP7B6TTNX4Q';



        try {
            const response = await getProject({
                id: this.id,
                hash: this.hash
            });
            console.log({ response });
            let data = JSON.parse(response.data.payload);
            console.log({ data });
            await this.store.loadConfiguration({productId: data.productId});
            this.updateConfiguration(data);
            return data
        } catch (err) {
            console.error(err);

            swalAlert({
                title: "Błąd",
                html: `Wystąpił błąd podczas wczytywania projektu.<br>${err.toString()}`
            })
        }
    }


    updateConfiguration(payload){
        console.groupCollapsed('updateConfiguration');
        const {productId, email, agree, steps = [], extra = []} = payload || {};
        if(productId !== this.store.product.id){
            throw new Error(`Invalid product id ${productId}`);
        }
        this.email = email;
        this.agree = agree;
        for(const step of steps){
            const {id, value} = step;
            this.store.setStepValue(id, value, {tracking: false});
        }
        for(const extraData of extra){
            this.store.addExtraProduct(extraData);
        }
        this.store.hasUnsavedChanges = false;
        console.groupEnd();
    }


    /**
     * MYB-121: the configuration JSON only (no user save id/hash, email or agree).
     * This is the payload persisted as a basket configuration.
     */
    buildConfiguration(){
        const store = this.store;
        const steps = store.sortedStepsFlat.map((step) => {
            return {
                id: step.id,
                value: step.value,
            };
        });

        const extra = store.extraSteps.map((step) => {
            return {
                id: step.id,
                value: step.value,
                type: step.type,
                productsOptions: step.extraProductsOptions
            }
        });

        return {
            productId: store.product.id,
            steps: steps,
            extra: extra
        };
    }

    preparePayload(){
        const payload = {
            ...this.buildConfiguration(),
            email: this.email,
            agree: this.agree,
        };

        if(this.id && this.hash){
            payload.id = this.id;
            payload.hash = this.hash;
        }
        
        return payload
    }

}